import React, { Component } from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom'
import {UserSelector} from '/app/src/model';
import Login from './Login'
import Dashboard from './Dashboard'

class Layout extends Component {
  render() {
      if(this.props.loggedIn) return <Dashboard/>
      return <Login/>
  }
}

function mapStateToProps(state, ownProps){
    return {
        loggedIn: UserSelector.isLoggedIn(state)
    }
}

export default withRouter(connect(mapStateToProps)(Layout));



// WEBPACK FOOTER //
// ./src/layout/index.js